export default __webpack_public_path__ + "static/media/2.9c57e59c.png";